export const email = 'E-MAIL'
export const eInvoice = 'E-INVOICE'

export default () => [
    { value: email, label: email },
    { value: eInvoice, label: eInvoice },
]
